import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { Animated, TouchableWithoutFeedback, StyleSheet, View, Keyboard, Platform } from 'react-native';
import { SafeAreaView } from '@react-navigation/native';
import CrossFadeIcon from './CrossFadeIcon';
import withDimensions from '../utils/withDimensions';
var majorVersion = parseInt(Platform.Version, 10);
var isIos = Platform.OS === 'ios';
var isIOS11 = majorVersion >= 11 && isIos;
var DEFAULT_MAX_TAB_ITEM_WIDTH = 125;

var TouchableWithoutFeedbackWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TouchableWithoutFeedbackWrapper, _React$Component);

  function TouchableWithoutFeedbackWrapper() {
    _classCallCheck(this, TouchableWithoutFeedbackWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(TouchableWithoutFeedbackWrapper).apply(this, arguments));
  }

  _createClass(TouchableWithoutFeedbackWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onPress = _this$props.onPress,
          onLongPress = _this$props.onLongPress,
          testID = _this$props.testID,
          accessibilityLabel = _this$props.accessibilityLabel,
          accessibilityRole = _this$props.accessibilityRole,
          accessibilityStates = _this$props.accessibilityStates,
          props = _objectWithoutProperties(_this$props, ["onPress", "onLongPress", "testID", "accessibilityLabel", "accessibilityRole", "accessibilityStates"]);

      return React.createElement(TouchableWithoutFeedback, {
        onPress: onPress,
        onLongPress: onLongPress,
        testID: testID,
        hitSlop: {
          left: 15,
          right: 15,
          top: 0,
          bottom: 5
        },
        accessibilityLabel: accessibilityLabel,
        accessibilityRole: accessibilityRole,
        accessibilityStates: accessibilityStates
      }, React.createElement(View, props));
    }
  }]);

  return TouchableWithoutFeedbackWrapper;
}(React.Component);

var TabBarBottom =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(TabBarBottom, _React$Component2);

  function TabBarBottom() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TabBarBottom);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabBarBottom)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      layout: {
        height: 0,
        width: 0
      },
      keyboard: false,
      visible: new Animated.Value(1)
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyboardShow", function () {
      return _this.setState({
        keyboard: true
      }, function () {
        return Animated.timing(_this.state.visible, {
          toValue: 0,
          duration: 150,
          useNativeDriver: true
        }).start();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyboardHide", function () {
      return Animated.timing(_this.state.visible, {
        toValue: 1,
        duration: 100,
        useNativeDriver: true
      }).start(function () {
        _this.setState({
          keyboard: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLayout", function (e) {
      var layout = _this.state.layout;
      var _e$nativeEvent$layout = e.nativeEvent.layout,
          height = _e$nativeEvent$layout.height,
          width = _e$nativeEvent$layout.width;

      if (height === layout.height && width === layout.width) {
        return;
      }

      _this.setState({
        layout: {
          height: height,
          width: width
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderLabel", function (_ref) {
      var route = _ref.route,
          focused = _ref.focused;
      var _this$props2 = _this.props,
          activeTintColor = _this$props2.activeTintColor,
          inactiveTintColor = _this$props2.inactiveTintColor,
          labelStyle = _this$props2.labelStyle,
          showLabel = _this$props2.showLabel,
          showIcon = _this$props2.showIcon,
          allowFontScaling = _this$props2.allowFontScaling;

      if (showLabel === false) {
        return null;
      }

      var label = _this.props.getLabelText({
        route: route
      });

      var tintColor = focused ? activeTintColor : inactiveTintColor;

      if (typeof label === 'string') {
        return React.createElement(Animated.Text, {
          numberOfLines: 1,
          style: [styles.label, {
            color: tintColor
          }, showIcon && _this._shouldUseHorizontalLabels() ? styles.labelBeside : styles.labelBeneath, labelStyle],
          allowFontScaling: allowFontScaling
        }, label);
      }

      if (typeof label === 'function') {
        return label({
          route: route,
          focused: focused,
          tintColor: tintColor
        });
      }

      return label;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderIcon", function (_ref2) {
      var route = _ref2.route,
          focused = _ref2.focused;
      var _this$props3 = _this.props,
          navigation = _this$props3.navigation,
          activeTintColor = _this$props3.activeTintColor,
          inactiveTintColor = _this$props3.inactiveTintColor,
          renderIcon = _this$props3.renderIcon,
          showIcon = _this$props3.showIcon,
          showLabel = _this$props3.showLabel;

      if (showIcon === false) {
        return null;
      }

      var horizontal = _this._shouldUseHorizontalLabels();

      var activeOpacity = focused ? 1 : 0;
      var inactiveOpacity = focused ? 0 : 1;
      return React.createElement(CrossFadeIcon, {
        route: route,
        horizontal: horizontal,
        navigation: navigation,
        activeOpacity: activeOpacity,
        inactiveOpacity: inactiveOpacity,
        activeTintColor: activeTintColor,
        inactiveTintColor: inactiveTintColor,
        renderIcon: renderIcon,
        style: [styles.iconWithExplicitHeight, showLabel === false && !horizontal && styles.iconWithoutLabel, showLabel !== false && !horizontal && styles.iconWithLabel]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_shouldUseHorizontalLabels", function () {
      var routes = _this.props.navigation.state.routes;
      var _this$props4 = _this.props,
          isLandscape = _this$props4.isLandscape,
          dimensions = _this$props4.dimensions,
          adaptive = _this$props4.adaptive,
          tabStyle = _this$props4.tabStyle;

      if (!adaptive) {
        return false;
      }

      if (Platform.isPad) {
        var maxTabItemWidth = DEFAULT_MAX_TAB_ITEM_WIDTH;
        var flattenedStyle = StyleSheet.flatten(tabStyle);

        if (flattenedStyle) {
          if (typeof flattenedStyle.width === 'number') {
            maxTabItemWidth = flattenedStyle.width;
          } else if (typeof flattenedStyle.maxWidth === 'number') {
            maxTabItemWidth = flattenedStyle.maxWidth;
          }
        }

        return routes.length * maxTabItemWidth <= dimensions.width;
      } else {
        return isLandscape;
      }
    });

    return _this;
  }

  _createClass(TabBarBottom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (Platform.OS === 'ios') {
        Keyboard.addListener('keyboardWillShow', this._handleKeyboardShow);
        Keyboard.addListener('keyboardWillHide', this._handleKeyboardHide);
      } else {
        Keyboard.addListener('keyboardDidShow', this._handleKeyboardShow);
        Keyboard.addListener('keyboardDidHide', this._handleKeyboardHide);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (Platform.OS === 'ios') {
        Keyboard.removeListener('keyboardWillShow', this._handleKeyboardShow);
        Keyboard.removeListener('keyboardWillHide', this._handleKeyboardHide);
      } else {
        Keyboard.removeListener('keyboardDidShow', this._handleKeyboardShow);
        Keyboard.removeListener('keyboardDidHide', this._handleKeyboardHide);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          navigation = _this$props5.navigation,
          keyboardHidesTabBar = _this$props5.keyboardHidesTabBar,
          activeBackgroundColor = _this$props5.activeBackgroundColor,
          inactiveBackgroundColor = _this$props5.inactiveBackgroundColor,
          onTabPress = _this$props5.onTabPress,
          onTabLongPress = _this$props5.onTabLongPress,
          safeAreaInset = _this$props5.safeAreaInset,
          style = _this$props5.style,
          tabStyle = _this$props5.tabStyle;
      var routes = navigation.state.routes;
      var tabBarStyle = [styles.tabBar, this._shouldUseHorizontalLabels() && !Platform.isPad ? styles.tabBarCompact : styles.tabBarRegular, style];
      return React.createElement(Animated.View, {
        style: [styles.container, keyboardHidesTabBar ? {
          // When the keyboard is shown, slide down the tab bar
          transform: [{
            translateY: this.state.visible.interpolate({
              inputRange: [0, 1],
              outputRange: [this.state.layout.height, 0]
            })
          }],
          // Absolutely position the tab bar so that the content is below it
          // This is needed to avoid gap at bottom when the tab bar is hidden
          position: this.state.keyboard ? 'absolute' : null
        } : null],
        pointerEvents: keyboardHidesTabBar && this.state.keyboard ? 'none' : 'auto',
        onLayout: this._handleLayout
      }, React.createElement(SafeAreaView, {
        style: tabBarStyle,
        forceInset: safeAreaInset
      }, routes.map(function (route, index) {
        var focused = index === navigation.state.index;
        var scene = {
          route: route,
          focused: focused
        };

        var accessibilityLabel = _this2.props.getAccessibilityLabel({
          route: route
        });

        var accessibilityRole = _this2.props.getAccessibilityRole({
          route: route
        });

        var accessibilityStates = _this2.props.getAccessibilityStates(scene);

        var testID = _this2.props.getTestID({
          route: route
        });

        var backgroundColor = focused ? activeBackgroundColor : inactiveBackgroundColor;
        var ButtonComponent = _this2.props.getButtonComponent({
          route: route
        }) || TouchableWithoutFeedbackWrapper;
        return React.createElement(ButtonComponent, {
          key: route.key,
          onPress: function onPress() {
            return onTabPress({
              route: route
            });
          },
          onLongPress: function onLongPress() {
            return onTabLongPress({
              route: route
            });
          },
          testID: testID,
          accessibilityLabel: accessibilityLabel,
          accessibilityRole: accessibilityRole,
          accessibilityStates: accessibilityStates,
          style: [styles.tab, {
            backgroundColor: backgroundColor
          }, _this2._shouldUseHorizontalLabels() ? styles.tabLandscape : styles.tabPortrait, tabStyle]
        }, _this2._renderIcon(scene), _this2._renderLabel(scene));
      })));
    }
  }]);

  return TabBarBottom;
}(React.Component);

_defineProperty(TabBarBottom, "defaultProps", {
  keyboardHidesTabBar: false,
  activeTintColor: '#007AFF',
  activeBackgroundColor: 'transparent',
  inactiveTintColor: '#8E8E93',
  inactiveBackgroundColor: 'transparent',
  showLabel: true,
  showIcon: true,
  allowFontScaling: true,
  adaptive: isIOS11,
  safeAreaInset: {
    bottom: 'always',
    top: 'never'
  }
});

var DEFAULT_HEIGHT = 49;
var COMPACT_HEIGHT = 29;
var styles = StyleSheet.create({
  tabBar: {
    backgroundColor: '#fff',
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0, 0, 0, .3)',
    flexDirection: 'row'
  },
  container: {
    left: 0,
    right: 0,
    bottom: 0,
    elevation: 8
  },
  tabBarCompact: {
    height: COMPACT_HEIGHT
  },
  tabBarRegular: {
    height: DEFAULT_HEIGHT
  },
  tab: {
    flex: 1,
    alignItems: isIos ? 'center' : 'stretch'
  },
  tabPortrait: {
    justifyContent: 'flex-end',
    flexDirection: 'column'
  },
  tabLandscape: {
    justifyContent: 'center',
    flexDirection: 'row'
  },
  iconWithoutLabel: {
    flex: 1
  },
  iconWithLabel: {
    flex: 1
  },
  iconWithExplicitHeight: {
    height: Platform.isPad ? DEFAULT_HEIGHT : COMPACT_HEIGHT
  },
  label: {
    textAlign: 'center',
    backgroundColor: 'transparent'
  },
  labelBeneath: {
    fontSize: 11,
    marginBottom: 1.5
  },
  labelBeside: {
    fontSize: 12,
    marginLeft: 15
  }
});
export default withDimensions(TabBarBottom);